module.exports = __webpack_public_path__ + "static/media/sk.a6ab3ac0.svg";